"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MapPin, Mail, Phone, Facebook, Instagram } from "lucide-react";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-5 w-24 bg-muted/40 animate-pulse rounded" />
        <div className="h-5 w-28 bg-muted/40 animate-pulse rounded" />
        <div className="h-5 w-32 bg-muted/40 animate-pulse rounded" />
      </div>;
  }
  const filteredMenuItems = menuItems.filter(item => item.label !== 'Home2');
  return <nav className="flex flex-col gap-3">
      {filteredMenuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-white hover:text-white/80 font-sans text-base transition-colors duration-[var(--duration-fast)]">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const {
    ref: col1Ref,
    isVisible: col1Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: col3Ref,
    isVisible: col3Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: col4Ref,
    isVisible: col4Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <footer id="footer" className="w-full bg-dark-background text-foreground-dark rounded-t-[32px] relative z-10 -mt-16 overflow-visible">
      <div className="px-6 pt-20 pb-16 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {}
          <div ref={col1Ref} className={`flex flex-col gap-6 transition-all duration-[250ms] ease-[var(--ease-smooth)] ${col1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <img src="https://tops-killdeer.10web.cloud/wp-content/uploads/2026/02/KS-LUXURY-RENOVATION-LOGO-04_resized350px.png" alt="Lumoria" className="w-[288px]" />
            <p className="text-white font-sans leading-relaxed -mt-[42px] !h-[130px] !m-0 !text-sm !font-normal ![padding:20px_30px_0px_0px]">
              Located in Limassol, <span className="font-semibold">KS LUXURY RENOVATIONS</span> provides high-end renovation and design & build services throughout Cyprus, working with private homeowners, developers, and businesses seeking uncompromising quality.
            </p>
          </div>

          {}
          <div ref={col3Ref} className="flex flex-col gap-6 transition-all duration-[250ms] ease-[var(--ease-smooth)] opacity-100 translate-y-0 delay-100 ![padding:20px_0px_20px_50px]">
            <MenuProvider menu_id="13">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div ref={col4Ref} className={`flex flex-col gap-6 transition-all duration-[250ms] ease-[var(--ease-smooth)] ${col4Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} delay-200`}>
            <h3 className="font-display text-[32px] font-bold text-white">Contact Us</h3>
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-3">
                <div className="flex items-center gap-3 text-white font-sans text-base">
                  <MapPin className="size-4 shrink-0" />
                  <span>Aisopou 17, Agios Nikolaos, 3100, Limassol</span>
                </div>
                <Link to="tel:+97673308" className="flex items-center gap-3 text-white hover:text-white/80 font-sans text-base transition-colors duration-[var(--duration-fast)]">
                  <Phone className="size-4 shrink-0" />
                  <span>97 673 308</span>
                </Link>
                <Link to="mailto:ks@theksway.com" className="flex items-center gap-3 text-white hover:text-white/80 font-sans text-base transition-colors duration-[var(--duration-fast)]">
                  <Mail className="size-4 shrink-0" />
                  <span className="!bg-transparent">ks@theksway.com</span>
                </Link>
              </div>
              <Button asChild className="inline-flex items-center justify-center gap-2 rounded-full bg-accent text-foreground-primary px-6 py-3 font-semibold hover:bg-accent-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-accent-active active:translate-y-0 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] self-start">
                <Link to="https://ksluxury.cloudtech.com.cy/get-a-quote/" className="whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-9 has-[>svg]:px-3 inline-flex items-center justify-center gap-2 rounded-full bg-accent text-foreground-primary px-6 py-3 font-semibold transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] self-start whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-9 has-[>svg]:px-3 inline-flex items-center justify-center gap-2 rounded-full bg-accent text-foreground-primary font-semibold transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] self-start whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-9 has-[>svg]:px-3 inline-flex items-center justify-center gap-2 rounded-full bg-accent text-foreground-primary font-semibold transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] self-start whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-9 has-[>svg]:px-3 inline-flex items-center justify-center gap-2 rounded-full bg-accent font-semibold transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] self-start !text-[hsl(0,0%,100%)] !p-6 !text-lg disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-accent-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-accent-active active:translate-y-0 disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-accent-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-accent-active active:translate-y-0 disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-accent-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-accent-active active:translate-y-0 disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-accent-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-accent-active active:translate-y-0">Request Consultation</Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <Separator className="my-8 bg-border" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-3 text-white font-sans text-sm">
            <p className="text-center sm:text-left">
              Copyright @ 2026. <span className="font-semibold">KS LUXURY RENOVATIONS</span>. All rights reserved.
            </p>
            <span className="hidden sm:inline text-white/40">|</span>
            <Link to="https://theksway.com/privacy-policy/" className="text-white hover:text-white/80 transition-colors duration-[var(--duration-fast)]">
              Privacy Policy
            </Link>
             <Link to="https://theksway.com/terms-and-conditions/" className="text-white hover:text-white/80 transition-colors duration-[var(--duration-fast)]">
              Terms & Conditions
            </Link>
            <Link to="https://theksway.com/disclaimer/" className="text-white hover:text-white/80 transition-colors duration-[var(--duration-fast)]">
              Disclaimer
            </Link>
          </div>
          <div className="flex items-center gap-4">
            <Link to="https://www.facebook.com/KSLuxuryRenovations" newTab className="text-white hover:text-[#8b6e4c] transition-colors duration-[var(--duration-fast)]" aria-label="Facebook">
              <Facebook className="size-5" />
            </Link>
            <Link to="https://www.instagram.com/the_ks_way/" newTab className="text-white hover:text-[#8b6e4c] transition-colors duration-[var(--duration-fast)]" aria-label="Instagram">
              <Instagram className="size-5" />
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}